import React, { useEffect } from "react";
import * as CONSTANTS from "../../utils/CONSTANTS";
import { makeSideBarActive } from "../../utils/EllowUtils";
import SideMenu from "../sideMenu";
import DashboardHeader from "../topbar";
import { useState } from "react";
import Styles from "./styles.module.scss";
import { viewedpageMixpanel } from "../../utils/mixpanel";
import ButtonDefault from "../../components/button";
import PublicDataTable from "./publicDataTable";
import PublicDatabaseModal from "../../modal/PublicDatabaseModal";
import { useNavigate } from "react-router-dom";
import UploadFiled from "../../components/fileduploader";
import { postAPI } from '../../api/api';
import { getCandidates } from "./services";
import { REACT_APP_PUBLICDATA } from "../../utils/common";
import NotificationAlert from "../../components/notification";
import { TabStrip, TabStripSelectEventArguments } from "@progress/kendo-react-layout";
import Tab from "../../components/tab";


function PublicDatabase() {

  const menu = makeSideBarActive(CONSTANTS.sideMenu, 2);
  const BreadcrumsValues = ["Public Database"];
  const [showModal, setShowModal] = useState<boolean>(false);
  const [selected, setSelected] = useState<number>(0);
  const [data, setData] = useState<any>([]);
  const [total, setTotal] = useState<any>([]);
  const [notification, setNotification] = useState<boolean>(false)
  const [message, setMessage] = useState<string>('')
  const [filterValues, setFilterValues] = useState<any>(null);

  const navigate = useNavigate();

  const getResources = (tabValue: string, pageSize: number, pageNumber: number, searchValue: string, filter?: any, sort?: any) => {
    getCandidates(tabValue, pageSize, pageNumber, searchValue, filter, sort).then((response) => {
      if (response && response.status === 1) {
        setData(response.data);
        setTotal(response.count);
      }
    });
  };

  useEffect(() => {
    getResources('airtable', 25, 1, '', '', '')
    viewedpageMixpanel();
  }, [showModal]);



  const getAllResources = (
    tabName: string,
    pageSize: any,
    pageNumber: number,
    searchValue: string,
    filters?: any,
    sort?: any
  ) => {
    let body: any = {};
    if (!filters) {
      body = {
        filters: {},
        sort: {
          sortBy: sort && sort.length > 0 ? sort[0].field : "",
          sortOrder: sort && sort.length > 0 ? sort[0].dir : "",
        },
      };
    } else {
      body = {
        filters,
        sort: {
          sortBy: sort && sort.length > 0 ? sort[0].field : "",
          sortOrder: sort && sort.length > 0 ? sort[0].dir : "",
        },
      };
    }
  };

  const searchChange = (e: string) => {
    getResources('airtable', 25, 1, e, '', '')

  };

  const closeTag = (data: any) => {
    let value = {
      filters: data,
    };
    applyFilter(value);
  };

  const applyFilter = (data: any) => {

    getResources('airtable', 25, 1, '', data)
    delete data.coreSkillsCombination
    delete data.positionStatusCombination
    data.filters.behalf_of = data.filters.behalf_of !== undefined ? data.filters.behalf_of.name : undefined 
    setFilterValues(data.filters)
  };

  const redirection = () => {
    navigate('/uploadhistory');
  }

  const importCandidates = () => {
    const data = {
      "allocated_to": localStorage.getItem('loginId')
    }
    postAPI( REACT_APP_PUBLICDATA + '/extractDataFromAirtable', data).then((resp: any) => {
      if(resp && resp.statusCode === 200){
        setNotification(true)
        setMessage(`${resp.data_length} records imported succesfully`)
      }else{
        setMessage('Failed to import data')
      }
    })
    
  }

  const onClose = () => {
    setNotification(false)
  }

  useEffect(() => {
   console.log(document.body.classList.contains('expandSideMenu'));
   
  }, [document.body.classList.contains('expandSideMenu')])
  

  const handleSelect = (e: TabStripSelectEventArguments) => {
    setSelected(e.selected);
  };
  
 let expanded = document.body.classList.contains('expandSideMenu')

  return (
    <section className="dashboardWrapper">
      {notification && <NotificationAlert onClose={onClose} closable={true} >
        {message}
      </NotificationAlert>}
      <SideMenu menu={menu} openresource={"publicdatabase"} />
      <div className="dashboardContent">
        <DashboardHeader
          title={BreadcrumsValues}
          applyResourceFilter={applyFilter}
          searchChange={selected === 0 ? searchChange : undefined}
          closeTag={closeTag}
          type='resources'
          filterValues={filterValues}
        />
        <section className={Styles.dashboardWrapper}>
          {/* <div className={Styles.buttonWrapper}>
            <ButtonDefault
              variant="primary"
              size="small"
              onClick={importCandidates}
            >
              Import verified Candidates
            </ButtonDefault>

            <ButtonDefault
              variant="primary"
              size="small"
              onClick={redirection}
            >
              Upload History
            </ButtonDefault>
          </div> */}
        </section>
        <section>
        <TabStrip selected={selected} onSelect={handleSelect}>
            <Tab title="Public DB Resources">
              <div className={Styles.tableWrapper}>
                <PublicDataTable
                  data={data}
                  total={total}
                  handlePageChange={{}}
                  getTablesValues={() => { }}
                  onClick={() => { }}
                />
              </div>
            </Tab>
            <Tab title="Airtable view">
              <iframe className="iframe" src="https://airtable.com/embed/shrWwX3cfjmw2vij9?backgroundColor=blue&viewControls=on" style={{ 'width': '100%', 'height': '600px' }} ></iframe>
            </Tab>
          </TabStrip>
          {/* <div className={Styles.tableWrapper}>
            <PublicDataTable
              data={data}
              total={total}
              handlePageChange={{}}
              getTablesValues={() => { }}
              onClick={() => { }}
            />
          </div> */}
        </section>
        {showModal && (

          <PublicDatabaseModal
            onClose={() => setShowModal(false)}
            clickHandler={{}}
            isUpload
            title="Upload"
          />
        )}
      </div>
    </section>
  );
}

export default PublicDatabase;
